import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastContainer } from './shared/components/toast-container/toast-container.component';
import { PdfViewerComponent } from './shared/components/pdf-viewer/pdf-viewer.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastContainer, PdfViewerComponent, CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <main class="min-h-screen w-full">
      <router-outlet />
      <app-toast-container></app-toast-container>
      <app-pdf-viewer></app-pdf-viewer>
    </main>
  `,
})
export class App {}
